module.exports = __webpack_public_path__ + "img/H4.762a052c.png";